import { render, staticRenderFns } from "./cRoleFlexQuestions.vue?vue&type=template&id=c4b6ddba&scoped=true"
import script from "./cRoleFlexQuestions.vue?vue&type=script&lang=js"
export * from "./cRoleFlexQuestions.vue?vue&type=script&lang=js"
import style0 from "./cRoleFlexQuestions.vue?vue&type=style&index=0&id=c4b6ddba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b6ddba",
  null
  
)

export default component.exports